module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl1-100.49f7c873.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/attack-bomber-squadrons-lvl1-100.png
// module id = 3505
// module chunks = 11